import React from 'react'

const PlayIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="75" height="82" viewBox="0 0 75 82">
      <path fillRule="evenodd" fill="#fff" d="M842,489l75,41-75,41V489Z" transform="translate(-842 -489)"/>
    </svg>
  )
}

export default PlayIcon

// const PlayIcon = () => {
//   return (
//     <svg width="79px" height="86px" viewBox="0 0 79 86" version="1.1" xmlns="http://www.w3.org/2000/svg">
//       <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <polygon id="Path" stroke="#FFFFFF" strokeWidth="4" points="1.60058594 2.93457031 1.60058594 83.5429688 75.7988281 43.2387695"></polygon>
//       </g>
//     </svg>
//   )
// }